import LegalLayout from "@/components/LegalLayout";
import { BUSINESS } from "@/lib/business";

export default function Privacidad() {
    return (
        <LegalLayout
            testId="privacidad-page"
            title="Política de Privacidad"
            intro={`En ${BUSINESS.name} nos tomamos muy en serio la privacidad y la protección de los datos personales. A continuación te explicamos cómo tratamos tus datos conforme al Reglamento (UE) 2016/679 (RGPD) y a la Ley Orgánica 3/2018 de Protección de Datos Personales y garantía de los derechos digitales (LOPDGDD).`}
        >
            <h2>1. Responsable del tratamiento</h2>
            <ul>
                <li><strong>Responsable:</strong> {BUSINESS.name}</li>
                <li><strong>CIF:</strong> {BUSINESS.cif}</li>
                <li><strong>Dirección:</strong> {BUSINESS.address}, {BUSINESS.postalCode} {BUSINESS.city}, {BUSINESS.province}</li>
                <li><strong>Teléfono:</strong> {BUSINESS.phone}</li>
                <li><strong>Email:</strong> {BUSINESS.email}</li>
            </ul>

            <h2>2. Datos que tratamos</h2>
            <p>
                Este sitio web <strong>no dispone de formularios de contacto</strong> ni recopila datos personales a través de la navegación más allá de las cookies técnicas necesarias para su correcto funcionamiento. Los únicos datos personales que podemos tratar son los que tú nos facilitas voluntariamente al contactarnos por teléfono o por correo electrónico.
            </p>

            <h2>3. Finalidad del tratamiento</h2>
            <p>Cuando nos contactas, tratamos tus datos con las siguientes finalidades:</p>
            <ul>
                <li>Responder a tu consulta o solicitud de presupuesto.</li>
                <li>Gestionar la prestación de los servicios que contrates.</li>
                <li>Cumplir con las obligaciones legales, contables y fiscales aplicables.</li>
            </ul>

            <h2>4. Base legal</h2>
            <p>La base jurídica para el tratamiento de tus datos es:</p>
            <ul>
                <li><strong>Consentimiento del interesado</strong> al contactar voluntariamente con nosotros.</li>
                <li><strong>Ejecución de un contrato</strong> cuando solicitas y contratas nuestros servicios.</li>
                <li><strong>Cumplimiento de obligaciones legales</strong> aplicables a nuestra actividad.</li>
            </ul>

            <h2>5. Plazo de conservación</h2>
            <p>
                Los datos personales se conservarán durante el tiempo necesario para cumplir con la finalidad para la que se recabaron, así como para atender las responsabilidades derivadas de la prestación de los servicios y cumplir con los plazos legales de conservación.
            </p>

            <h2>6. Destinatarios</h2>
            <p>
                Tus datos no se comunicarán a terceros salvo obligación legal. Para la prestación de servicios podemos trabajar con proveedores que actúan como encargados del tratamiento, con quienes mantenemos los contratos exigidos por la normativa.
            </p>

            <h2>7. Derechos del interesado</h2>
            <p>Puedes ejercer en cualquier momento los siguientes derechos:</p>
            <ul>
                <li>Derecho de <strong>acceso</strong> a tus datos personales.</li>
                <li>Derecho de <strong>rectificación</strong> de datos inexactos.</li>
                <li>Derecho de <strong>supresión</strong> (“derecho al olvido”).</li>
                <li>Derecho de <strong>oposición</strong> al tratamiento.</li>
                <li>Derecho a la <strong>limitación</strong> del tratamiento.</li>
                <li>Derecho a la <strong>portabilidad</strong> de los datos.</li>
                <li>Derecho a no ser objeto de decisiones automatizadas.</li>
            </ul>
            <p>
                Para ejercer estos derechos puedes escribirnos a <a href={BUSINESS.emailHref}>{BUSINESS.email}</a> adjuntando copia del DNI o documento equivalente que acredite tu identidad.
            </p>
            <p>
                Además, tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (<a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>) si consideras que el tratamiento no se ajusta a la normativa vigente.
            </p>

            <h2>8. Medidas de seguridad</h2>
            <p>
                {BUSINESS.name} adopta las medidas técnicas y organizativas necesarias para garantizar la seguridad de los datos personales y evitar su alteración, pérdida o tratamiento no autorizado, teniendo en cuenta el estado de la técnica, los costes de aplicación y la naturaleza, alcance y fines del tratamiento.
            </p>

            <h2>9. Modificaciones</h2>
            <p>
                Nos reservamos el derecho a modificar esta Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales. En tales casos, anunciaremos en el sitio los cambios con antelación razonable.
            </p>

            <p className="mt-10 text-sm text-brand-ink/60">Última actualización: {new Date().toLocaleDateString("es-ES", { year: "numeric", month: "long" })}.</p>
        </LegalLayout>
    );
}
